import { Box } from "@mui/system";
import { Button, Typography } from "@platform/design-system";

interface FinalDecisionsHeaderProps {
  buttonConfig: { show: boolean; text: string };
  isFinalDecisionLoading?: boolean;
  onFinalDecisionClick: VoidFunction;
  onMarketingPresentationClick?: VoidFunction;
}

export const FinalDecisionsHeader = ({
  buttonConfig,
  isFinalDecisionLoading,
  onFinalDecisionClick,
}: FinalDecisionsHeaderProps): React.JSX.Element => (
  <Box display="flex" justifyContent="space-between" alignItems="center">
    <Typography variant="display-small" sx={{ fontWeight: 400 }}>
      Final Decisions
    </Typography>
    <Box display="flex" alignItems="center" gap={2}>
      {buttonConfig.show && (
        <Button
          variant="primary"
          loading={isFinalDecisionLoading}
          onClick={onFinalDecisionClick}
        >
          {buttonConfig.text}
        </Button>
      )}
    </Box>
  </Box>
);
